<!--
 * @Author: your name
 * @Date: 2022-04-11 16:03:18
 * @LastEditTime: 2022-05-07 11:08:44
 * @LastEditors: pangshuting 2723947616@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \rotateActivity\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data () {
    return {};
  },
  methods: {
    // url参数解析
    getUrlParams (url) {
      var params = {};
      url = decodeURIComponent(url)
      if(url.indexOf("?")>0){
        var urls = url.split("?");
        sessionStorage.setItem("baseUrl", urls[0]);
        if(urls[1]){
          var arr = urls[1].split("&");
          for (var i = 0, l = arr.length; i < l; i++) {
            var a = arr[i].split("=");
            params[a[0]] = a[1];
          }
        }
      }
      return params;
    },
  },
  created () {
    let backUrl = location.href.replace(/\#\//g, '');//替换掉`#/`
    console.log(backUrl)
    // if(backUrl.indexOf("unionid")<0){
    //     backUrl="http://localhost:8080/#/index?unionid=odWWF1h65nIMDEvZqzYSG1dzDkBM&storeCode=37360&t=1635926309318&shopId=3103/";
    // }
    let params = this.getUrlParams(backUrl);
    console.log(params);
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html,
body {
  height: 100%;
  width: 100%;
  /* background-color: #1E94D3; */
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  height: 100%;
}
.mint-indicator-wrapper {
  z-index: 1000 !important;
}
.mint-indicator-mask {
  z-index: 1000 !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue